/**
 * @file cc-form-utils.js
 * General form utility module for the Credit Calculator Wizards pages.
 *
 * Responsibilities:
 *  - CSRF setup — injects the CakePHP CSRF token into every jQuery AJAX request header.
 *  - `scrollToResultsWhenReady()` — smoothly scrolls to `#credit-calculator-results`
 *    after a form submit or bfcache page-restore, with a MutationObserver fallback.
 *  - Enter key guard — prevents accidental form submission from text/email/radio fields.
 *  - Radio error clear — removes validation error styles when a radio is clicked.
 *  - Reset handler — clears hidden predictive `value` attributes on form reset.
 *  - Apply-for-credit guard — blocks navigation if the cart exceeds 30 items.
 */

/**
 * CSRF setup — inject token into every jQuery AJAX request.
 */
$.ajaxSetup({
    headers: {
        "X-CSRF-Token": typeof csrfToken !== "undefined" ? csrfToken : "",
    },
});

let lastResultsScrollAt = 0;

/**
 * Smoothly scrolls the page to `#credit-calculator-results` once it is visible in the DOM.
 * Includes an 800 ms debounce to avoid duplicate scrolls on rapid triggers.
 * If the element is not yet present, a MutationObserver watches for it and scrolls
 * as soon as it appears. The observer is torn down after `timeoutMs` milliseconds
 * regardless, with a console warning if the target was never found.
 *
 * @param {number} [timeoutMs=15000] Maximum time (ms) to wait for the results element.
 */
function scrollToResultsWhenReady(timeoutMs = 15000) {
    const now = Date.now();
    if (now - lastResultsScrollAt < 800) {
        return;
    }
    lastResultsScrollAt = now;

    const targetSelector = "#credit-calculator-results";

    function tryScroll() {
        const el = document.querySelector(targetSelector);
        if (el && el.offsetParent !== null) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
            return true;
        }
        return false;
    }

    if (tryScroll()) return;

    const obs = new MutationObserver(() => {
        if (tryScroll()) {
            obs.disconnect();
        }
    });

    obs.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
        obs.disconnect();
        if (!tryScroll()) {
            console.warn(
                "[CC] Results not found within timeout, no scroll performed.",
            );
        }
    }, timeoutMs);
}

/**
 * Scroll to results after form submit / page restore.
 */
$(document).on("submit", "#credit-wizard-form", function () {
    scrollToResultsWhenReady();
});

window.addEventListener("pageshow", function () {
    scrollToResultsWhenReady(5000);
});


/**
 * Prevent Enter key from submitting text / email / radio fields.
 */
$(document).on(
    "keyup keypress",
    'form input[type="text"], input[type="email"], input[type="radio"]',
    function (e) {
        if (e.which === 13) {
            e.preventDefault();
            return false;
        }
    },
);


/**
 * Clear radio error state on click.
 */
$('input[type="radio"]').click(function (e) {
    $(e.currentTarget).closest("div").find("span").text("");
    $(e.currentTarget).closest("div").find("span").addClass("visibility-hidden");
    $(e.currentTarget).closest("div").removeClass("error");
});


/**
 * Reset form — clear hidden predictive `value` attributes.
 */
$(":reset").click(function () {
    $(this)
        .closest("form")
        .find("input[type=hidden]")
        .attr("value", "");
});


/**
 * Apply-for-credit — guard against cart exceeding 30 items.
 */
$(".apply-for-credit").click(function (e) {
    e.preventDefault();
    var href = $(this).attr("href");

    $.get("/credit-calculator-wizards/getCreditCartCount").always(function (data) {
        if (data > 30) {
            alert(
                "Number of credits have exceeded 30.  Please reduce number of credits.",
            );
        } else {
            window.location.href = href;
        }
    });
});
